import React from 'react';
import { linkTo } from '@99designs/feature-auth';
import { Box, SolidAnchorButton } from '@99designs/ui';
import { Layout } from './common/Layout';

function Masquerading() {
    return (
        <Layout title="Masquerading" heading="Masquerading">
            <Box>Login is unavailable while masquerading.</Box>

            <SolidAnchorButton href={linkTo.logout()} variant="primary" width="fill">
                Log out
            </SolidAnchorButton>
        </Layout>
    );
}

export default Masquerading;
